import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';
import { useMemo } from 'react';

import ValidationError from '../../components/ValidationError/ValidationError';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { addOrUpdateFormField } from '../../store/applicationform';
import { selectFieldStateByName } from '../../store/applicationform/applicationFormSelectors';
import { IFieldState } from '../../store/applicationform/applicationFormTypes';
import CountryCodeSelect from './CountryCodeSelection';

type Props = {
    name: string;
    label?: string;
    options: SelectFieldOption[];
};
const CountryCodeSelectionField = ({ name, label, options }: Props) => {
    const dispatch = useAppDispatch();
    const fieldState = useAppSelector(selectFieldStateByName)(name);

    const selectedIds = useMemo(() => {
        const fieldValue = fieldState?.value;
        if (Array.isArray(fieldValue)) {
            return options
                .filter(
                    (option) =>
                        (fieldValue as string[]).includes(option.label as string) ||
                        (fieldValue as string[]).includes(String(option.id)),
                )
                .map((option) => String(option.id));
        }
        if (typeof fieldValue === 'string' && fieldValue.length) {
            const matchedOption = options.find(
                (option) => option.label === fieldValue || String(option.id) === fieldValue,
            );
            return matchedOption?.id != null ? [String(matchedOption.id)] : [];
        }
        return [];
    }, [fieldState?.value, options]);

    const onChange = (newIds: string[]) => {
        dispatch(
            addOrUpdateFormField({
                fieldName: name,
                value: newIds,
                label: label,
                hasError: false,
                errorMessage: undefined,
            } as IFieldState),
        );
    };

    return (
        <>
            <CountryCodeSelect name={name} options={options} onChange={onChange} value={selectedIds} label={label} />
            <ValidationError fieldName={name} />
        </>
    );
};

export default CountryCodeSelectionField;
